import { getCookie, setJusbrasilCookie } from '@jusbrasil-web/shared-utils-cookies'
import { IncomingMessage, ServerResponse } from 'http'

import { JUSBRASIL_EXPERIENCE_ALERT_VIEWED } from '../constants'

const getJusbrasilExperienceAlertViewKey = (pid = 'user') => {
  return `${pid}-${JUSBRASIL_EXPERIENCE_ALERT_VIEWED}`
}

const setJusbrasilExperienceAlertView = (pid = 'user', response: ServerResponse | null = null) => {
  setJusbrasilCookie(response, getJusbrasilExperienceAlertViewKey(pid), Date.now())
}

const getJusbrasilExperienceAlertView = (pid = 'user', request: IncomingMessage | null = null) => {
  return getCookie(request, getJusbrasilExperienceAlertViewKey(pid))
}

export const jusbrasilExperiencePersistentAlertBannerPersisted = {
  getKey: getJusbrasilExperienceAlertViewKey,
  set: setJusbrasilExperienceAlertView,
  get: getJusbrasilExperienceAlertView,
}
